<a [routerLink]="['/']" [class]="'navbar-brand mw-100 ' + classes">
  <img class="img-thumbnail bg-transparent p-0 border-0" [src]="src" [alt]="description" height="60px">
</a>
